// ** React Imports
import { useState, useEffect, SyntheticEvent } from 'react'

import appInfo from '../../../../configs/app-info';

import Box from '@mui/material/Box'
import Card from '@mui/material/Card'
import CardHeader from '@mui/material/CardHeader'
import Button from '@mui/material/Button'
import Typography from '@mui/material/Typography'
import CardContent from '@mui/material/CardContent'
import Grid, { GridProps } from '@mui/material/Grid';
import { styled, useTheme } from '@mui/material/styles'
import FormControl from '@mui/material/FormControl'
import TextField from '@mui/material/TextField'
import FormHelperText from '@mui/material/FormHelperText'
import CircularProgress from '@mui/material/CircularProgress'
import FormLabel from '@mui/material/FormLabel'
import {
    CardActions,
    Divider,
    IconButton,
    InputAdornment,
    Radio,
    RadioGroup,
    Tooltip,
    Fab,
    FormControlLabel,
    Checkbox,
    OutlinedInput,
    Rating,
    Autocomplete
} from '@mui/material'

import Select from '@mui/material/Select'
import MenuItem from '@mui/material/MenuItem'
import InputLabel from '@mui/material/InputLabel'

import Dialog from '@mui/material/Dialog'
import DialogTitle from '@mui/material/DialogTitle'
import DialogContent from '@mui/material/DialogContent'
import DialogContentText from '@mui/material/DialogContentText'
import DialogActions from '@mui/material/DialogActions'

import { useNavigate, useParams, useSearchParams } from "react-router-dom";
import { Controller, useForm } from 'react-hook-form'
import axios from 'axios'
import Swal from 'sweetalert2'
import moment from 'moment'
// import 'moment/locale/id'

import Icon from '../../../../components/icon';
import MsiDatagridDynamic from '../../../../components/custom/MsiDatagridDynamic';
import apiUrl from '../../../../configs/constant';
import MsiDatagrid from '../../../../components/custom/MsiDatagridAuto';
import FloatingJurnalButton from '../../../../components/acc/jurnal/FabJurnal';
import { dataSource } from '../../../../sample-data/example-funnel';

export default function Add() {
    const userData = JSON.parse(localStorage.getItem('user')!)
    const user = userData.data
    const token = userData.token

    const { id } = useParams()
    const cabang = JSON.parse(localStorage.getItem('cabang')!)

    const [searchParams] = useSearchParams();
    const isMasuk = searchParams.get('is_masuk') || 'default';
    const [docId, setDocId] = useState<any>(null)

    const [valDoctag, setValDoctag] = useState<any>(null)
    const [listDoctag, setListDoctag] = useState<any[]>([])

    const [valAkunDetail, setValAkunDetail] = useState<any>(null)
    const [valAkunUbah, setValAkunUbah] = useState<any>(null)
    const [valAkun, setValAkun] = useState<any>(null)
    const [listAkun, setListAkun] = useState<any[]>([])

    const [listDetail, setListDetail] = useState<any[]>([])

    const [openDialog, setOpenDialog] = useState<boolean>(false)
    const [openDialogUbah, setOpenDialogUbah] = useState<boolean>(false)

    const [listProfitCenter, setListProfitCenter] = useState<any[]>([])
    const [profitCenter, setProfitCenter] = useState<any>(null)

    useEffect(() => {
        getDetail()
    }, [])

    const getDetail = () => {
        const url = apiUrl.apiUrl + '/acc/mutasi-kas/get-detail/' + id
        axios
            .get(url, {
                params: {},
                headers: { Authorization: `Bearer ${token}` }
            })
            .then(response => {
                if (response.data.success) {
                    const data = response.data

                    const master = data.master[0]

                    setDocId(master.doc_id)
                    setValue('sysdoctag_id', master.sysdoctag_id)
                    getDoctag(master.sysdoctag_id)

                    setValue('accakun_id', master.accakun_id)
                    setValue('accakun_id_ubah', master.accakun_id)
                    getAkun(master.accakun_id)

                    getListProfitCenter()

                    setValue('tgl', moment(master.tgl).format('YYYY-MM-DD'))
                    setValue('tgl_ubah', moment(master.tgl).format('YYYY-MM-DD'))
                    setValue('keterangan', master.keterangan)
                    setValue('keterangan_ubah', master.keterangan_ubah)
                    setValue('is_masuk', master.is_masuk)
                    setValue('kepada', master.kepada)
                    setValue('total_valas', master.total_valas)
                    setValue('total', master.total)
                    setValue('deleted_at', master.deleted_at)

                    setListDetail(data.detail)
                } else {
                    Swal.fire({
                        title: 'Pemberitahuan',
                        text: response.data.message,
                        icon: 'error'
                    })
                }
            })
    }

    const getDoctag = (doctag: any) => {
        const url = apiUrl.apiUrl + '/acc/mutasi-kas/get-doctag'

        axios
            .get(url, {
                params: {},
                headers: { Authorization: `Bearer ${token}` }
            })
            .then(response => {
                if (response.data.success) {
                    const data = response.data.data
                    data.forEach((element: any) => {
                        if (element.id == doctag) {
                            setValDoctag(element)
                        }
                    });
                    setListDoctag(data)
                } else {
                    Swal.fire({
                        title: 'Pemberitahuan',
                        text: response.data.message,
                        icon: 'error'
                    })
                }
            })
    }

    const getAkun = (accakun_id: any) => {

        const url = apiUrl.apiUrl + '/acc/mutasi-kas/list-akun'

        axios
            .get(url, {
                params: {},
                headers: { Authorization: `Bearer ${token}` }
            })
            .then(response => {
                if (response.data.success) {
                    const data = response.data.data
                    if (Array.isArray(data)) {
                        data.forEach((item: any) => {
                            if (item && item.id != null && item.nama != null) item.nama = `${item.id} | ${item.nama} | Saldo: ${item.saldo ?? 0}`
                        })
                    }
                    data.forEach((element: any) => {
                        if (element.id == accakun_id) {
                            setValAkun(element)
                            setValAkunUbah(element)
                        }
                    });
                    setListAkun(data)
                } else {
                    Swal.fire({
                        title: 'Pemberitahuan',
                        text: response.data.message,
                        icon: 'error'
                    })
                }
            })
    }

    const getListProfitCenter = () => {
        let url = apiUrl.apiUrl + '/acc/penyesuaian/list-profit-center'

        axios
            .get(url, {
                params: {},
                headers: { Authorization: `Bearer ${token}` }
            })
            .then(response => {
                const data = response.data.data
                setListProfitCenter(data)
            })
    }

    interface FormInputs {
        syscabang_id: any
        sysdoctag_id: any
        accakun_id: any
        sysmatauang_id: any
        jenis_transaksi: any
        keterangan: any
        total_valas: any
        total: any
        tgl: any
        kepada: any
        is_masuk: any
        deleted_at: any

        accakun_id_detail: any
        accprofitcenter_id: any
        keterangan_detail: any
        total_detail: any
        valas_detail: any

        tgl_ubah: any
        accakun_id_ubah: any
        keterangan_ubah: any
    }

    const defaultValues = {
        syscabang_id: 1,
    }

    // ** Hooks
    const {
        control,
        handleSubmit,
        setValue,
        getValues,
        resetField,
        formState: { errors }
    } = useForm<FormInputs>({ defaultValues })

    const onSubmit = (data: any) => {
        Swal.fire({
            title: 'Konfirmasi',
            html: 'Apakah anda ingin menyimpan data ini ?',
            icon: 'question',
            showCancelButton: true,
            confirmButtonColor: '#337ab7',
            cancelButtonColor: '#ffc107',
            confirmButtonText: 'Simpan'
        }).then(result => {
            if (result.isConfirmed) {
                Swal.fire({
                    title: 'Now loading',
                    allowEscapeKey: false,
                    allowOutsideClick: false,
                    didOpen: () => {
                        Swal.showLoading()
                    }
                })

                const url = apiUrl.apiUrl + '/acc/mutasi-kas/update/' + id
                axios
                    .post(url, data, {
                        headers: { Authorization: `Bearer ${token}` }
                    })
                    .then(response => {
                        if (response.data.success) {
                            Swal.fire({
                                title: 'Pemberitahuan',
                                html: response.data.message,
                                icon: 'success',
                                timer: 1000,
                                timerProgressBar: true,
                                willClose: () => {
                                    getDetail()
                                }
                            })
                        } else {
                            Swal.fire({
                                title: 'Pemberitahuan',
                                html: response.data.message,
                                icon: 'error'
                            })
                        }
                    })
                    .catch(error => {
                        Swal.fire({
                            title: 'Pemberitahuan',
                            text: error.message,
                            icon: 'error'
                        })
                    })
            }
        })
    }

    const addDetail = (data: any) => {
        setOpenDialog(false)

        const send = {
            accprofitcenter_id: data.accprofitcenter_id,
            accakun_id: data.accakun_id_detail,
            keterangan: data.keterangan_detail,
            total: data.total_detail,
            valas: data.valas_detail
        }

        const url = apiUrl.apiUrl + '/acc/mutasi-kas/add-detail/' + id
        axios
            .post(url, send, {
                headers: { Authorization: `Bearer ${token}` }
            })
            .then(response => {
                if (response.data.success) {
                    Swal.fire({
                        title: 'Pemberitahuan',
                        html: response.data.message,
                        icon: 'success',
                        timer: 1000,
                        timerProgressBar: true,
                        willClose: () => {
                            getDetail()
                        }
                    })
                } else {
                    Swal.fire({
                        title: 'Pemberitahuan',
                        html: response.data.message,
                        icon: 'error'
                    })
                }
            })
            .catch(error => {
                Swal.fire({
                    title: 'Pemberitahuan',
                    text: error.message,
                    icon: 'error'
                })
            })
    }

    const handleChangeDoctag = (event: SyntheticEvent, newValue: any | null) => {
        setValue('sysdoctag_id', newValue?.id)
        setValDoctag(newValue)
    }

    const handleChangeAkun = (event: SyntheticEvent, newValue: any | null) => {
        setValue('accakun_id', newValue?.id)
        setValue('jenis_transaksi', newValue?.nama)
        setValAkun(newValue)
    }

    const handleChangeAkunDetail = (event: SyntheticEvent, newValue: any | null) => {
        setValue('accakun_id_detail', newValue?.id)
        setValAkunDetail(newValue)
    }

    const handleChangeAkunUbah = (event: SyntheticEvent, newValue: any | null) => {
        setValue('accakun_id_ubah', newValue?.id)
        setValAkunUbah(newValue)
    }

    const handleChangeProfitCenter = (event: SyntheticEvent, newValue: any | null) => {
        setValue('accprofitcenter_id', newValue?.id)
        setProfitCenter(newValue)
    }

    const renderMaster = () => {
        return (
            <CardContent>
                <Grid container spacing={3}>
                    <Grid item xs={12} sm={6} hidden>
                        <Typography variant='body1' sx={{ fontWeight: 'bold', mb: 1.5 }}>
                            Document
                        </Typography>
                        <FormControl fullWidth>
                            <Controller
                                name='sysdoctag_id'
                                control={control}
                                rules={{ required: true }}
                                render={({ field: { value, onChange } }) => (
                                    <Autocomplete
                                        value={valDoctag}
                                        options={listDoctag}
                                        id='sysdoctag_id'
                                        disabled
                                        isOptionEqualToValue={(option, value) => option.id === value.id}
                                        onChange={handleChangeDoctag}
                                        renderOption={(props, option) => {
                                            return (
                                                <li {...props} key={option.id}>
                                                    {option.name_tag}
                                                </li>
                                            )
                                        }}
                                        getOptionLabel={option => option.name_tag}
                                        renderInput={params => (
                                            <TextField
                                                {...params}
                                                label='Document'
                                                error={Boolean(errors.sysdoctag_id)}
                                                InputLabelProps={{ shrink: true }}
                                            />
                                        )}
                                    />
                                )}
                            />
                            {errors.sysdoctag_id && (
                                <FormHelperText sx={{ color: 'error.main' }}>Form ini tidak boleh kosong.</FormHelperText>
                            )}
                        </FormControl>
                    </Grid>
                    <Grid item xs={12} sm={6}>
                        <Typography variant='body1' sx={{ fontWeight: 'bold', mb: 1.5 }}>
                            Akun
                        </Typography>
                        <FormControl fullWidth>
                            <Controller
                                name='accakun_id'
                                control={control}
                                rules={{ required: true }}
                                render={({ field: { value, onChange } }) => (
                                    <Autocomplete
                                        value={valAkun}
                                        options={listAkun}
                                        id='accakun_id'
                                        disabled
                                        isOptionEqualToValue={(option, value) => option.id === value.id}
                                        onChange={handleChangeAkun}
                                        renderOption={(props, option) => {
                                            return (
                                                <li {...props} key={option.id}>
                                                    {option.nama}
                                                </li>
                                            )
                                        }}
                                        getOptionLabel={option => option.nama}
                                        renderInput={params => (
                                            <TextField
                                                {...params}
                                                label='Akun'
                                                error={Boolean(errors.accakun_id)}
                                                InputLabelProps={{ shrink: true }}
                                            />
                                        )}
                                    />
                                )}
                            />
                            {errors.accakun_id && (
                                <FormHelperText sx={{ color: 'error.main' }}>Form ini tidak boleh kosong.</FormHelperText>
                            )}
                        </FormControl>
                    </Grid>
                    <Grid item xs={12} sm={6}>
                        <Typography variant='body1' sx={{ fontWeight: 'bold', mb: 1.5 }}>
                            Tanggal Transaksi
                        </Typography>
                        <FormControl fullWidth>
                            <Controller
                                name='tgl'
                                control={control}
                                rules={{ required: true }}
                                render={({ field: { value, onChange } }) => (
                                    <TextField
                                        label='Tanggal Transaksi'
                                        type='date'
                                        error={Boolean(errors.tgl)}
                                        onChange={onChange}
                                        value={value}
                                        InputLabelProps={{ shrink: true }}
                                    />
                                )}
                            />
                            {errors.tgl && (
                                <FormHelperText sx={{ color: 'error.main' }}>Form ini tidak boleh kosong.</FormHelperText>
                            )}
                        </FormControl>
                    </Grid>
                    <Grid item xs={12} sm={6}>
                        <Typography variant='body1' sx={{ fontWeight: 'bold', mb: 1.5 }}>
                            Tujuan
                        </Typography>
                        <FormControl fullWidth>
                            <Controller
                                name='kepada'
                                control={control}
                                rules={{ required: false }}
                                render={({ field: { value, onChange } }) => {
                                    return (
                                        <TextField
                                            label='Tujuan'
                                            error={Boolean(errors.kepada)}
                                            onChange={onChange}
                                            value={value}
                                            InputLabelProps={{ shrink: true }}
                                        />
                                    )
                                }}
                            />
                            {errors.kepada && (
                                <FormHelperText sx={{ mt: 0, color: 'error.main' }}>
                                    Form ini tidak boleh kosong.
                                </FormHelperText>
                            )}
                        </FormControl>
                    </Grid>
                    <Grid item xs={12} sm={6}>
                        <Typography variant='body1' sx={{ fontWeight: 'bold', mb: 1.5 }}>
                            Total Valas
                        </Typography>
                        <FormControl fullWidth>
                            <Controller
                                name='total_valas'
                                control={control}
                                rules={{ required: true }}
                                render={({ field: { value, onChange } }) => {
                                    return (
                                        <TextField
                                            fullWidth
                                            disabled
                                            label='Total Valas'
                                            name='total_valas'
                                            value={
                                                value !== undefined && value !== null && value !== ''
                                                    ? (() => {
                                                        // Format value for display: replace dot with comma, add thousand separator
                                                        const str = String(value).replace('.', ',')
                                                        const [integer, decimal] = str.split(',')
                                                        let formatted = integer ? Number(integer).toLocaleString('id-ID') : ''
                                                        if (decimal !== undefined) {
                                                            formatted += ',' + decimal
                                                        }
                                                        return formatted
                                                    })()
                                                    : ''
                                            }
                                            onChange={e => {
                                                let input = e.target.value

                                                // Remove all except digits and comma
                                                input = input.replace(/[^0-9,]/g, '')

                                                // Split integer and decimal part
                                                const [intPart, decimalPart] = input.split(',')

                                                // Format integer part with thousand separator
                                                let formatted = ''
                                                if (intPart) {
                                                    const parsed = parseInt(intPart, 10)
                                                    formatted = isNaN(parsed) ? '' : parsed.toLocaleString('id-ID')
                                                }
                                                if (decimalPart !== undefined) {
                                                    formatted += ',' + decimalPart
                                                }

                                                // Raw value for backend: replace comma with dot
                                                const rawValue = decimalPart !== undefined ? `${intPart}.${decimalPart}` : intPart

                                                setValue('total_valas', rawValue)
                                                setValue('total', rawValue)
                                            }}
                                            InputLabelProps={{ shrink: true }}
                                            inputProps={{ inputMode: 'decimal' }}
                                        />
                                    )
                                }}
                            />
                            {errors.total_valas && (
                                <FormHelperText sx={{ mt: 0, color: 'error.main' }}>
                                    Form ini tidak boleh kosong.
                                </FormHelperText>
                            )}
                        </FormControl>
                    </Grid>
                    <Grid item xs={12} sm={12}>
                        <Typography variant='body1' sx={{ fontWeight: 'bold', mb: 1.5 }}>
                            Keterangan
                        </Typography>
                        <FormControl fullWidth>
                            <Controller
                                name='keterangan'
                                control={control}
                                rules={{ required: false }}
                                render={({ field: { value, onChange } }) => {
                                    return (
                                        <TextField
                                            label='Keterangan'
                                            rows={2}
                                            multiline
                                            error={Boolean(errors.keterangan)}
                                            onChange={onChange}
                                            value={value}
                                            InputLabelProps={{ shrink: true }}
                                        />
                                    )
                                }}
                            />
                            {errors.keterangan && (
                                <FormHelperText sx={{ mt: 0, color: 'error.main' }}>
                                    Form ini tidak boleh kosong.
                                </FormHelperText>
                            )}
                        </FormControl>
                    </Grid>
                </Grid>
                <Box
                    sx={{
                        pt: 5,
                        display: 'flex',
                        flexWrap: 'wrap',
                        alignItems: 'center',
                        justifyContent: 'center'
                    }}
                >
                    <Button size='large' type='submit' sx={{ width: 'auto' }} variant='contained'
                        disabled={docId != null ? true : false} >
                        UBAH DATA
                    </Button>
                </Box>
                {user.sysrole_id == 1 || user.sysrole_id == 12 ? (
                    <Box
                        sx={{
                            pt: 3,
                            display: 'flex',
                            flexWrap: 'wrap',
                            alignItems: 'center',
                            justifyContent: 'center'
                        }}
                    >
                        <Button size='large' onClick={() => setOpenDialogUbah(true)} sx={{ width: 'auto' }} variant='contained'>
                            UBAH KHUSUS
                        </Button>
                    </Box>
                ) : ('')}
            </CardContent>
        )
    }

    const deleteRows = (ids: any) => {
        Swal.fire({
            title: 'Konfirmasi',
            text: `Apakah anda ingin hapus data ini ?`,
            icon: 'question',
            showCancelButton: true,
            confirmButtonColor: '#337ab7',
            cancelButtonColor: '#ffc107',
            confirmButtonText: 'Hapus'
        }).then(result => {
            if (result.isConfirmed) {
                Swal.fire({
                    title: 'Now loading',
                    allowEscapeKey: false,
                    allowOutsideClick: false,
                    didOpen: () => {
                        Swal.showLoading()
                    }
                })

                const url = apiUrl.apiUrl + '/acc/mutasi-kas/delete-detail/' + ids
                axios
                    .post(url, {}, {
                        headers: { Authorization: `Bearer ${token}` }
                    })
                    .then(response => {
                        if (response.data.success) {
                            Swal.fire({
                                title: 'Pemberitahuan',
                                text: response.data.message,
                                icon: 'success',
                                timer: 1000,
                                timerProgressBar: true,
                                willClose: () => {
                                    getDetail()
                                }
                            })
                        } else {
                            Swal.fire({
                                title: 'Pemberitahuan',
                                text: response.data.message,
                                icon: 'error'
                            })
                        }
                    })
                    .catch(error => {
                        Swal.fire({
                            title: 'Pemberitahuan',
                            text: error.message,
                            icon: 'error'
                        })
                    })

            }
        })
    }

    const ActionButtons = ({ row, onDelete }: {
        row: any;
        onDelete: (id: string) => void
    }) => {
        const actions = [
            {
                title: "Hapus",
                icon: "mdi:trash",
                color: "red",
                onClick: () => onDelete(row.id)
            }
        ];
        return (
            <Box sx={{ display: "flex", alignItems: "center" }}>
                {actions.map(action => (
                    <Tooltip key={action.title} title={action.title} placement="top">
                        <IconButton onClick={action.onClick}
                            disabled={docId != null ? true : false}>
                            <Icon icon={action.icon} color={action.color} />
                        </IconButton>
                    </Tooltip>
                ))}
            </Box>
        );
    };

    const actionData = [
        {
            key: "aksi",
            flex: 1,
            sortable: false,
            minWidth: 50,
            field: "aksi",
            align: "center",
            headerAlign: "center",
            headerName: "Aksi",
            renderCell: ({ row }: { row: any }) => (
                <ActionButtons
                    row={row}
                    onDelete={deleteRows}
                />
            ),
        },
    ];

    const renderDetail = () => {
        return (
            <CardContent>
                <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'flex-start' }}>
                    <Button
                        sx={{
                            my: 5
                        }}
                        variant='contained'
                        color='primary'
                        startIcon={<Icon icon='mdi:plus' />}
                        onClick={() => {
                            setOpenDialog(true)
                            setValAkunDetail(null)
                            resetField('accakun_id_detail')
                            resetField('keterangan_detail')
                            resetField('total_detail')
                        }}
                        disabled={docId != null ? true : false}
                    >
                        Tambah Data
                    </Button>
                </Box>

                <MsiDatagrid array={listDetail} hiddenColumns={['id', 'valas']} actions={actionData} />
            </CardContent >
        )
    }

    const submitUbahKhusus = () => {
        setOpenDialogUbah(false)

        const data = getValues()
        // console.log('SUBMIT', data)

        const payload = {
            keterangan_ubah: data.keterangan_ubah,
            tgl: data.tgl_ubah,
            accakun_id: data.accakun_id_ubah
        }

        Swal.fire({
            title: 'Konfirmasi',
            text: 'Apakah anda ingin menyimpan perubahan?',
            icon: 'question',
            showCancelButton: true,
            confirmButtonText: 'Simpan'
        }).then(result => {
            if (!result.isConfirmed) return

            Swal.fire({
                title: 'Loading...',
                allowEscapeKey: false,
                allowOutsideClick: false,
                didOpen: () => {
                    Swal.showLoading()
                }
            })

            const url = apiUrl.apiUrl + '/acc/mutasi-kas/update-khusus/' + id

            axios.post(url, payload, {
                headers: {
                    Authorization: `Bearer ${token}`
                }
            })
                .then(res => {
                    Swal.fire({
                        icon: 'success',
                        title: 'Berhasil',
                        text: res.data.message ?? 'Data berhasil diubah'
                    })

                    setOpenDialogUbah(false)
                    getDetail()
                })
                .catch(err => {
                    Swal.fire({
                        icon: 'error',
                        title: 'Error',
                        text: err.response?.data?.message || err.message
                    })
                })
        })
    }

    return (
        <Grid container spacing={6} sx={{ display: 'flex', flexWrap: 'wrap', justifyContent: 'center' }}>
            <Grid item xl={12} md={12} xs={12}>
                <Fab variant='extended' color='primary' sx={{ '& svg': { mr: 1 } }} onClick={() => window.history.back()}>
                    <Icon icon='mdi:arrow-left' />
                    Kembali
                </Fab>
                <div className={'content-block dx-card'} style={{ paddingRight: 20, paddingLeft: 20, paddingBottom: 10, paddingTop: 10 }}>
                    <Typography variant='h5' sx={{ textAlign: 'center' }}>
                        Detail Mutasi Kas Bank
                    </Typography>
                    <Typography variant='body1' sx={{ textAlign: 'center', mb: 2 }}>
                        No. Dokumen : <b>{id}</b>
                    </Typography>
                    <Typography variant='body1' sx={{ textAlign: 'center', mb: 2 }}>
                        Jenis Mutasi : <b>{getValues('is_masuk') == 1 ? 'KAS MASUK' : 'KAS KELUAR'}</b>
                    </Typography>
                    <Divider sx={{ m: 0 }} />
                    <form onSubmit={handleSubmit(onSubmit)}>
                        {renderMaster()}
                        <Divider />
                        {renderDetail()}
                    </form>
                </div>
            </Grid>

            <Dialog
                maxWidth={'sm'}
                fullWidth={true}
                open={openDialog}
                onClose={() => setOpenDialog(false)}
                aria-labelledby='form-dialog-title'
            >
                <DialogTitle id='form-dialog-title'>
                    <Typography variant='h6' sx={{ fontWeight: 500, mb: 1.5, color: '#212121' }}>
                        Tambah Data
                    </Typography>
                </DialogTitle>
                <DialogContent sx={{ color: '#212121' }}>
                    <Grid container spacing={2}>
                        <Grid item xs={12} sm={12}>
                            <Typography variant='body1' sx={{ fontWeight: 'bold', mb: 1.5 }}>
                                Akun
                            </Typography>
                            <FormControl fullWidth>
                                <Controller
                                    name='accakun_id_detail'
                                    control={control}
                                    rules={{ required: true }}
                                    render={({ field: { value, onChange } }) => (
                                        <Autocomplete
                                            value={valAkunDetail}
                                            options={listAkun}
                                            id='accakun_id_detail'
                                            isOptionEqualToValue={(option, value) => option.id === value.id}
                                            onChange={handleChangeAkunDetail}
                                            renderOption={(props, option) => {
                                                return (
                                                    <li {...props} key={option.id}>
                                                        {option.nama}
                                                    </li>
                                                )
                                            }}
                                            getOptionLabel={option => option.nama}
                                            renderInput={params => (
                                                <TextField
                                                    {...params}
                                                    label='Akun'
                                                    error={Boolean(errors.accakun_id_detail)}
                                                    InputLabelProps={{ shrink: true }}
                                                />
                                            )}
                                        />
                                    )}
                                />
                                {errors.accakun_id_detail && (
                                    <FormHelperText sx={{ color: 'error.main' }}>Form ini tidak boleh kosong.</FormHelperText>
                                )}
                            </FormControl>
                        </Grid>
                        <Grid item xs={12} sm={12}>
                            <Typography variant='body1' sx={{ fontWeight: 'bold', mb: 1.5 }}>
                                Profit Center
                            </Typography>
                            <FormControl fullWidth>
                                <Autocomplete
                                    value={profitCenter}
                                    options={listProfitCenter}
                                    id='profitCenter'
                                    isOptionEqualToValue={(option, value) => option.id === value.id}
                                    onChange={handleChangeProfitCenter}
                                    renderOption={(props, option) => {
                                        return (
                                            <li {...props} key={option.id}>
                                                {option.kode} - {option.nama_profitcenter}
                                            </li>
                                        )
                                    }}
                                    getOptionLabel={option => option.nama_profitcenter}
                                    renderInput={params => <TextField {...params} label='Profit Center' />}
                                />
                                {errors.accprofitcenter_id && (
                                    <FormHelperText sx={{ color: 'error.main' }}>Form ini tidak boleh kosong.</FormHelperText>
                                )}
                            </FormControl>
                        </Grid>
                        <Grid item xs={12} sm={12}>
                            <Typography variant='body1' sx={{ fontWeight: 'bold', mb: 1.5 }}>
                                Total
                            </Typography>
                            <FormControl fullWidth>
                                <Controller
                                    name='total_detail'
                                    control={control}
                                    rules={{ required: true }}
                                    render={({ field: { value, onChange } }) => {
                                        return (
                                            <TextField
                                                fullWidth
                                                label='Total'
                                                name='total_detail'
                                                value={
                                                    value !== undefined && value !== null && value !== ''
                                                        ? (() => {
                                                            // Format value for display: replace dot with comma, add thousand separator
                                                            const str = String(value).replace('.', ',')
                                                            const [integer, decimal] = str.split(',')
                                                            let formatted = integer ? Number(integer).toLocaleString('id-ID') : ''
                                                            if (decimal !== undefined) {
                                                                formatted += ',' + decimal
                                                            }
                                                            return formatted
                                                        })()
                                                        : ''
                                                }
                                                onChange={e => {
                                                    let input = e.target.value

                                                    // Remove all except digits and comma
                                                    input = input.replace(/[^0-9,]/g, '')

                                                    // Split integer and decimal part
                                                    const [intPart, decimalPart] = input.split(',')

                                                    // Format integer part with thousand separator
                                                    let formatted = ''
                                                    if (intPart) {
                                                        const parsed = parseInt(intPart, 10)
                                                        formatted = isNaN(parsed) ? '' : parsed.toLocaleString('id-ID')
                                                    }
                                                    if (decimalPart !== undefined) {
                                                        formatted += ',' + decimalPart
                                                    }

                                                    // Raw value for backend: replace comma with dot
                                                    const rawValue = decimalPart !== undefined ? `${intPart}.${decimalPart}` : intPart

                                                    setValue('total_detail', rawValue)
                                                    setValue('valas_detail', rawValue)
                                                }}
                                                InputLabelProps={{ shrink: true }}
                                                inputProps={{ inputMode: 'decimal' }}
                                            />
                                        )
                                    }}
                                />
                                {errors.total_detail && (
                                    <FormHelperText sx={{ mt: 0, color: 'error.main' }}>
                                        Form ini tidak boleh kosong.
                                    </FormHelperText>
                                )}
                            </FormControl>
                        </Grid>
                        <Grid item xs={12} sm={12}>
                            <Typography variant='body1' sx={{ fontWeight: 'bold', mb: 1.5 }}>
                                Keterangan
                            </Typography>
                            <FormControl fullWidth>
                                <Controller
                                    name='keterangan_detail'
                                    control={control}
                                    rules={{ required: false }}
                                    render={({ field: { value, onChange } }) => {
                                        return (
                                            <TextField
                                                label='Keterangan'
                                                rows={2}
                                                multiline
                                                error={Boolean(errors.keterangan_detail)}
                                                onChange={onChange}
                                                value={value}
                                                InputLabelProps={{ shrink: true }}
                                            />
                                        )
                                    }}
                                />
                                {errors.keterangan_detail && (
                                    <FormHelperText sx={{ mt: 0, color: 'error.main' }}>
                                        Form ini tidak boleh kosong.
                                    </FormHelperText>
                                )}
                            </FormControl>
                        </Grid>
                        <Grid item xs={12} sm={12}>
                            <Button variant='contained' fullWidth onClick={() => addDetail(getValues())} color='primary'>
                                SIMPAN
                            </Button>
                        </Grid>
                    </Grid>
                </DialogContent>
                <DialogActions className='dialog-actions-dense'>
                    <Button onClick={() => setOpenDialog(false)}>Batal</Button>
                </DialogActions>
            </Dialog>

            {/* <Dialog
                maxWidth={'sm'}
                fullWidth={true}
                open={openDialogUbah}
                onClose={() => setOpenDialogUbah(false)}
                aria-labelledby='form-dialog-title'
            >
                <DialogTitle id='form-dialog-title'>
                    <Typography variant='h6' sx={{ fontWeight: 500, mb: 1.5, color: '#212121' }}>
                        UBAH KHUSUS
                    </Typography>
                </DialogTitle>
                <form onSubmit={handleSubmit((data) => {
                    setOpenDialogUbah(false)

                    const payload = {
                        keterangan_ubah: data.keterangan_ubah,
                        tgl: data.tgl_ubah,
                        accakun_id: data.accakun_id_ubah
                    }

                    const url = apiUrl.apiUrl + '/acc/mutasi-kas/update-khusus/' + id

                    axios.post(url, payload, {
                        headers: { Authorization: `Bearer ${token}` }
                    }).then(res => {
                        getDetail()
                    })

                })}>
                    <DialogContent sx={{ color: '#212121' }}>
                        <Grid container spacing={2}>
                            <Grid item xs={12} sm={12}>
                                <Typography variant='body1' sx={{ fontWeight: 'bold', mb: 1.5 }}>
                                    Akun
                                </Typography>
                                <FormControl fullWidth>
                                    <Controller
                                        name='accakun_id_ubah'
                                        control={control}
                                        rules={{ required: false }}
                                        render={({ field: { value, onChange } }) => (
                                            <Autocomplete
                                                value={valAkunUbah}
                                                options={listAkun}
                                                id='accakun_id_ubah'
                                                isOptionEqualToValue={(option, value) => option.id === value.id}
                                                onChange={(event, newValue) => {
                                                    onChange(newValue?.id)
                                                    handleChangeAkunUbah(event, newValue)
                                                }}
                                                renderOption={(props, option) => {
                                                    return (
                                                        <li {...props} key={option.id}>
                                                            {option.nama}
                                                        </li>
                                                    )
                                                }}
                                                getOptionLabel={option => option.nama}
                                                renderInput={params => (
                                                    <TextField
                                                        {...params}
                                                        label='Akun'
                                                        error={Boolean(errors.accakun_id_ubah)}
                                                        InputLabelProps={{ shrink: true }}
                                                    />
                                                )}
                                            />
                                        )}
                                    />
                                    {errors.accakun_id_ubah && (
                                        <FormHelperText sx={{ color: 'error.main' }}>Form ini tidak boleh kosong.</FormHelperText>
                                    )}
                                </FormControl>
                            </Grid>
                            <Grid item xs={12} sm={12}>
                                <Typography variant='body1' sx={{ fontWeight: 'bold', mb: 1.5 }}>
                                    Tanggal
                                </Typography>
                                <FormControl fullWidth>
                                    <Controller
                                        name='tgl_ubah'
                                        control={control}
                                        rules={{ required: false }}
                                        render={({ field: { value, onChange } }) => (
                                            <TextField
                                                label='Tanggal'
                                                type='date'
                                                error={Boolean(errors.tgl_ubah)}
                                                onChange={onChange}
                                                value={value}
                                                InputLabelProps={{ shrink: true }}
                                            />
                                        )}
                                    />
                                    {errors.tgl_ubah && (
                                        <FormHelperText sx={{ color: 'error.main' }}>Form ini tidak boleh kosong.</FormHelperText>
                                    )}
                                </FormControl>
                            </Grid>
                            <Grid item xs={12} sm={12}>
                                <Typography variant='body1' sx={{ fontWeight: 'bold', mb: 1.5 }}>
                                    Keterangan Ubah
                                </Typography>
                                <FormControl fullWidth>
                                    <Controller
                                        name='keterangan_ubah'
                                        control={control}
                                        rules={{ required: false }}
                                        render={({ field: { value, onChange } }) => {
                                            return (
                                                <TextField
                                                    label='Keterangan Ubah'
                                                    rows={2}
                                                    multiline
                                                    error={Boolean(errors.keterangan_ubah)}
                                                    onChange={onChange}
                                                    value={value}
                                                    InputLabelProps={{ shrink: true }}
                                                />
                                            )
                                        }}
                                    />
                                    {errors.keterangan_ubah && (
                                        <FormHelperText sx={{ mt: 0, color: 'error.main' }}>
                                            Form ini tidak boleh kosong.
                                        </FormHelperText>
                                    )}
                                </FormControl>
                            </Grid>
                            <Grid item xs={12} sm={12}>
                                <Button variant='contained' fullWidth type='submit' color='primary'
                                    onClick={() => console.log('CLICK')}>
                                    SIMPAN
                                </Button>
                            </Grid>
                        </Grid>
                    </DialogContent>
                </form>
                <DialogActions className='dialog-actions-dense'>
                    <Button onClick={() => setOpenDialogUbah(false)}>Batal</Button>
                </DialogActions>
            </Dialog> */}
            <Dialog
                maxWidth='sm'
                fullWidth
                open={openDialogUbah}
                onClose={() => setOpenDialogUbah(false)}
            >
                <DialogTitle>
                    <Typography variant='h6'>
                        UBAH KHUSUS
                    </Typography>
                </DialogTitle>

                <DialogContent>
                    <Grid container spacing={2} sx={{ mt: 1 }}>
                        <Grid item xs={12}>
                            <Typography variant='body1' sx={{ fontWeight: 'bold', mb: 1 }}>
                                Akun
                            </Typography>

                            <FormControl fullWidth>
                                <Controller
                                    name='accakun_id_ubah'
                                    control={control}
                                    render={({ field: { onChange } }) => (
                                        <Autocomplete
                                            value={valAkunUbah}
                                            options={listAkun}
                                            isOptionEqualToValue={(option, value) =>
                                                option.id === value.id
                                            }
                                            onChange={(event, newValue) => {
                                                onChange(newValue?.id)
                                                setValue('accakun_id_ubah', newValue?.id)
                                                setValAkunUbah(newValue)
                                            }}
                                            renderOption={(props, option) => (
                                                <li {...props} key={option.id}>
                                                    {option.nama}
                                                </li>
                                            )}
                                            getOptionLabel={option => option.nama}
                                            renderInput={params => (
                                                <TextField
                                                    {...params}
                                                    label='Akun'
                                                />
                                            )}
                                        />
                                    )}
                                />
                            </FormControl>
                        </Grid>

                        <Grid item xs={12}>
                            <Typography variant='body1' sx={{ fontWeight: 'bold', mb: 1 }}>
                                Tanggal
                            </Typography>

                            <Controller
                                name='tgl_ubah'
                                control={control}
                                render={({ field }) => (
                                    <TextField
                                        {...field}
                                        fullWidth
                                        type='date'
                                        label='Tanggal'
                                        InputLabelProps={{
                                            shrink: true
                                        }}
                                    />
                                )}
                            />
                        </Grid>

                        <Grid item xs={12}>
                            <Typography variant='body1' sx={{ fontWeight: 'bold', mb: 1 }}>
                                Keterangan Ubah
                            </Typography>

                            <Controller
                                name='keterangan_ubah'
                                control={control}
                                render={({ field }) => (
                                    <TextField
                                        {...field}
                                        fullWidth
                                        multiline
                                        rows={3}
                                        label='Keterangan Ubah'
                                        InputLabelProps={{
                                            shrink: true
                                        }}
                                    />
                                )}
                            />
                        </Grid>

                        <Grid item xs={12}>
                            <Button
                                variant='contained'
                                fullWidth
                                onClick={submitUbahKhusus}
                            >
                                SIMPAN
                            </Button>
                        </Grid>
                    </Grid>
                </DialogContent>

                <DialogActions>
                    <Button onClick={() => setOpenDialogUbah(false)}>
                        Batal
                    </Button>
                </DialogActions>
            </Dialog>

            <FloatingJurnalButton
                id={Number(id)}
                tabel="accmutasi"
            />
        </Grid>
    )
}
